import { Error } from "@ui/error/Error";
import Panel from "@ui/panel/Panel";
import { ITabItemProps, Tabs } from "@ui/tabs/Tabs";
import { RecursiveCSS } from "@ui/theme/GlobalTheme";
import { ReactElement, useState } from "react";

export const ContentPopup = ({
	closePopup,
	label,
	busy,
	extendedSectionID,
	children,
	expandedWidth,
	error,
	selected,
}: {
	closePopup: () => void;
	label: string;
	busy?: boolean;
	extendedSectionID: number;
	expandedWidth?: string;
	error?: any;
	children?: (ReactElement<ITabItemProps> | null)[] | ReactElement<ITabItemProps>;
	selected?: number;
}) => {
	const [state, setState] = useState<"small" | "full">("small");

	let sx: RecursiveCSS = {};
	if (state === "small") {
		sx = { maxWidth: "620px", minWidth: "420px", width: "99vw", minHeight: "95vh", maxHeight: "95vh" };
	} else {
		sx = { maxWidth: expandedWidth ?? "1020px", minWidth: "420px", width: "99vw", minHeight: "95vh", maxHeight: "95vh" };
	}

	sx = {
		...sx,
		transition: "all .2s",
	};

	return (
		<Panel sx={sx} busy={busy} decorator="absolute" label={label} onClose={closePopup}>
			{error && <Error error={error} />}
			<Tabs
				selected={selected}
				scrollable
				variant="modern"
				spaceBottom={20}
				onSectionSelect={section => {
					if (section > extendedSectionID) {
						setState("full");
					} else setState("small");
				}}>
				{children}
			</Tabs>
		</Panel>
	);
};
